import { DialogRoot, Flex, Text } from '@chakra-ui/react';
import { capitalize } from '@/utils/capitalize';
import { Divider } from '@/components/ui/Divider';
import { DialogBody, DialogContent, DialogHeader } from '@/components/ui/dialog';
import { templateTypeOptions } from '@/utils/coding-details';

interface LinkProps {
    data: {
        templateType: string;
        title: string;
    };
    onClose: () => void;
}

export function LinkModal({ data: { templateType, title }, onClose }: LinkProps) {
    const templateOption = templateTypeOptions.find((opt) => opt.value === templateType);

    return (
        <DialogRoot open onInteractOutside={onClose} motionPreset="slide-in-bottom">
            <DialogContent px="1">
                <DialogHeader>
                    <Text fontSize="md" fontWeight="bold">
                        {capitalize(templateOption?.label || '')}
                    </Text>
                </DialogHeader>
                <DialogBody>
                    <Flex flexDir="column" gap="4">
                        <p>{capitalize(title)}</p>
                        <Divider />
                    </Flex>
                </DialogBody>
            </DialogContent>
        </DialogRoot>
    );
}
